module.exports = __webpack_public_path__ + "static/media/zimbara.c9857a35.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/zimbara.png
// module id = 249
// module chunks = 0